import useTranslate from "@/hooks/useTranslate";
import { STORAGE_KEYS } from "@/constants/const_var";
import { is_en_gl_link } from "@/i18n/lang";
import classNames from "classnames";
import { speakText } from "@/utils/speakText";
import { homeAtom } from "@/atoms/home";
import { isLongText } from "@/utils/isLongText";
import { useCptUtil_04 } from "@/hooks/useCptUtil_04.tsx";
const BaseWeather: React.FC = () => {
  const { dayjs, userTimeZone } = useDayjs();
  const homeData = useAtomValue(homeAtom);
  const { current = {} } = homeData?.data ?? {};
  const { $t } = useTranslate();
  const { getCpt07, getCpt09, getCpt10 } = useCptUtil_04({
    current,
    $t,
    dayjs,
    userTimeZone,
    isLongText,
    is_en_gl_link,
  });
  const handleSpeakClick = () => {
    const temperature = current?.Temperature?.Value ? `${current.Temperature.Value} degrees Celsius` : "";
    const weatherText = current?.WeatherText ? `Weather: ${current.WeatherText}` : "";
    const realFeelTemperature = current?.RealFeelTemperature?.Value
      ? `Real Feel Temperature: ${current.RealFeelTemperature.Value} degrees Celsius`
      : "";
    const realFeelTemperatureShade = current?.RealFeelTemperatureShade?.Value
      ? `Real Feel Temperature Shade: ${current.RealFeelTemperatureShade.Value} degrees Celsius`
      : "";
    const past24HourRange =
      current?.Past24HourRange?.Maximum?.Value && current?.Past24HourRange?.Minimum?.Value
        ? `Temperature Range: ${current.Past24HourRange.Minimum.Value} to ${current.Past24HourRange.Maximum.Value} degrees Celsius`
        : "";
    const text = [
      $t("title01"),
      current?.SpecialDate,
      weatherText,
      temperature,
      past24HourRange,
      realFeelTemperature,
      realFeelTemperatureShade,
    ]
      .filter(Boolean)
      .join(". ");

    speakText(text);
  };

  const checkAndRefresh = () => {
    // 检查 Temperature.Value 是否为空
    if (!current?.Temperature?.Value) {
      // 获取当前 URL 的查询参数
      const urlParams = new URLSearchParams(window.location.search);
      // 去掉 keyId 参数
      urlParams.delete(STORAGE_KEYS.KEY_ID);
      // 构建新的 URL
      const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
      // 检查是否已经刷新过
      const lastRefresh = LocalStorage.getItem("lastRefresh");
      const now = new Date().getTime();
      // 如果上次刷新时间不存在或已过期，则刷新页面
      if (!lastRefresh || (now - parseInt(lastRefresh)) / 1000 > 5 * 60 * 1000) {
        LocalStorage.clear();
        LocalStorage.setItem("lastRefresh", now.toString());
        window.location.href = newUrl;
      }
    }
  };
  // 在组件中调用该函数
  useEffect(() => {
    checkAndRefresh();
  }, [current?.Temperature?.Value]);

  return (
    <>
      <WeatherContent
        className={classNames(["rounded-10", "bg-[var(--app-bg-08)]", "flex flex-col gap-y-16 backdrop-blur-10 p-16"])}
        onClick={handleSpeakClick}
      >
        {getCpt10()}

        {getCpt07()}

        {getCpt09()}
      </WeatherContent>
    </>
  );
};
export default BaseWeather;
